import React, { useEffect, useState } from "react";

import "./Patients.css";
import "../Commons/Commons.css";

import BtnDropdown from "../Commons/Buttons/BtnDropdown";
import SidebarMenu from "../Sidebar/Sidebar";
import AntDTable from "../AntDTable/AntDTable";
// import TextField from "../Commons/Forms/TextField";
import CustomBtnDownloadTable from "../Commons/Buttons/CustomBtnDownloadTable";

import { Col, Row } from "react-bootstrap";
import { useNavigate, useLocation } from "react-router-dom";
import { fetchPatientSearch } from "../Helpers/API/PatientApi/PatientApi";
import {
  capitalizeFirstLetter,
  formatDate,
  formatDateWithTime,
  getRole,
  getTodayDateISO,
} from "../Helpers/Utilities/Common";
import { Input, Button } from "antd";
import BtnAdd from "../Commons/Buttons/BtnAdd";
const { Search } = Input;

function PatientManager() {
  const navigate = useNavigate();
  const location = useLocation();
  const role = getRole();
  const [allPatients, setAllPatients] = useState([]);
  const [showLoader, setShowLoader] = useState(false);
  const [totalSize, setTotalSize] = useState(0);
  const [filterConfig, setFilterConfig] = useState({
    branch_id: 2,
    page: 1,
    total_records_per_page: 10,
    is_updated: false,
    search: "",
  });
  
  // Capture queue state from Dashboard Consult button
  const queueState = location.state?.queue_no ? {
    queue_no: location.state.queue_no,
    queue_id: location.state.queue_id,
    patient_id: location.state.patient_id,
    master_patient_id: location.state.master_patient_id,
  } : null;

  const handleChange = (e) => {
    setFilterConfig((prev) => ({
      ...prev,
      search: e || "",
      page: 1,
    }));
  };

  const handleEmpty = (e) => {
    if (e.target.value === "") {
      setFilterConfig((prev) => ({
        ...prev,
        search: e.target.value || "",
        page: 1,
      }));
    }
  };

  const handleTableChange = (pagination) => {
    setFilterConfig((prev) => ({
      ...prev,
      page: parseInt(pagination.current),
      total_records_per_page: pagination.pageSize,
    }));
  };

  // Custom row click handler that forwards queue state
  const handleRowClick = (record) => {
    const id = record.id;
    // Forward queue state if coming from Consult button and patient ID matches
    if (queueState && queueState.patient_id === id) {
      navigate(`/patients/profile/${id}`, { state: queueState });
    } else {
      navigate(`/patients/profile/${id}`);
    }
  };

  //get patient API
  async function getPatients() {
    setShowLoader(true);
    const response = await fetchPatientSearch(filterConfig);
    if (response.data) {
      var _allPatients = response.data.data;
      var _parsed = _allPatients.map((patient) => {
        const isFpeDone =
          patient?.fpe_done === 1 ||
          patient?.fpe_done === "1" ||
          patient?.is_fpe === 1 ||
          patient?.is_fpe === "1" ||
          (patient?.fpes && patient?.fpes.length > 0);
        const lastFpeDate =
          patient?.fpes?.[0]?.added_on ||
          patient?.added_on ||
          patient?.last_fpe_date ||
          patient?.fpe_last_date ||
          patient?.fpe_date ||
          patient?.last_fpe ||
          patient?.latest_fpe ||
          patient?.social_history_latest_date ||
          "";
        return {
          ...patient,
          added_on: formatDateWithTime(patient.added_on),
          fomatted_sex: capitalizeFirstLetter(patient.sex),
          color_tag: (
            <div
              style={{
                width: 30,
                height: 50,
                backgroundColor: patient.hmo_type
                  ? "#273DE9"
                  : patient.corporate_type
                  ? patient.corporate_type.toLowerCase() === "gmc-mg"
                    ? "#fa8c16"
                    : "#fadb14"
                  : "transparent",
                textAlign: "center",
              }}
            />
          ),
          raw_color_tag: patient.hmo_type
            ? "hmo"
            : patient.corporate_type
            ? patient.corporate_type.toLowerCase() === "gmc-mg"
              ? "gmc-mg"
              : "corporate"
            : "none",
          status: isFpeDone
            ? lastFpeDate
              ? formatDate(lastFpeDate) + " " + "(FPE Done)"
              : "FPE Done"
            : (
                <Button
                  type="primary"
                  size="small"
                  onClick={(e) => {
                    e.stopPropagation();
                    navigate(`/patients/profile/${patient.id}`, {
                      state: { selectedTab: "health_screening" },
                    });
                  }}
                >
                 Add FPE
                </Button>
              ),
        };
      });
      setAllPatients(_parsed);
      setTotalSize(response.data.size);
    } else {
      setAllPatients([]);
    }
    setShowLoader(false);
  }

  useEffect(() => {
    if (filterConfig?.search !== "") {
      getPatients();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterConfig]);

  useEffect(() => {
    const state = location.state || {};
    if (state?.searchTerm) {
      setFilterConfig((prev) => ({
        ...prev,
        search: state.searchTerm,
        page: 1,
      }));
    }
  }, [location.state]);

  return (
    <div className="App">
      <SidebarMenu active={"Patients"} />
      <div className="col pt-4 scrollable-container">
        <Row className="px-5 mb-4">
          <Col className="col font-big title-2 all-patient all-patients-title">
            All Patients
          </Col>
          <Col xs={2} className="patient-manager allPatients-buttons">
            <CustomBtnDownloadTable
              label={"Download PDF"}
              size={"sm"}
              fetchData={async () => {
                const allFilter = {
                  ...filterConfig,
                  page: "",
                  total_records_per_page: "",
                };
                const response = await fetchPatientSearch(allFilter);
                if (response.data) {
                  const fullData = response.data.data.map((patient) => ({
                    ...patient,
                    added_on: formatDateWithTime(patient.added_on),
                    fomatted_sex: capitalizeFirstLetter(patient.sex),
                    raw_color_tag: patient.hmo_type
                      ? "hmo"
                      : patient.corporate_type
                      ? patient.corporate_type.toLowerCase() === "gmc-mg"
                        ? "gmc-mg"
                        : "corporate"
                      : "none",
                  }));
                  return fullData;
                }
                return [];
              }}
              columns={[
                { header: "", dataKey: "raw_color_tag" },
                { header: "NAME", dataKey: "formatted_patient_name" },
                { header: "AGE", dataKey: "age" },
                { header: "SEX", dataKey: "fomatted_sex" },
                { header: "CONTACT NO.", dataKey: "phone_no" },
                { header: "ADDED ON", dataKey: "added_on" },
                { header: "ADDED BY", dataKey: "added_by_name" },
              ]}
              fileName={`${getTodayDateISO()} List of Patients.pdf`}
              pdfHeader={{
                title: "List of Patients",
                content: `This list of patients is generated on ${formatDateWithTime(
                  new Date()
                )}.`,
              }}
            />
          </Col>
          {/* <Col xs={2} className="patient-manager">
            <BtnDropdown
              label="+ Add"
              options={[
                {
                  label: "New Patient",
                  onClick: () => navigate("/patients/add/new-patient"),
                },
                {
                  label: "Diagnosis Patient",
                  onClick: () => navigate("/patients/add/diagnosis-patient"),
                },
              ]}
            />
          </Col> */}
          {/* <Col xs={2} className="patient-manager">
            <BtnAdd
              label={"+ Add Patient"}
              size={"sm"}
              onClick={() => navigate("/patients/add/new-patient")}
            />
          </Col> */}
        </Row>
        <div className="row ms-5">
          <div className="col-5 pe-4 me-2 mb-2 half-width">
            <Search
              placeholder="Search patient..."
              size="medium"
              onSearch={(e) => handleChange(e)}
              onChange={(e) => handleEmpty(e)}
              className="responsive-header-input"
            />
          </div>
        </div>
        <div className="row justify-content-center">
          <div className="col-sm-11 all-table custom-table-styling">
            <AntDTable
              tableHeaders={[
                "",
                "NAME",
                "AGE",
                "SEX",
                "BIRTHDATE",
                "STATUS"
                // "CONTACT NO.",
                // "ADDED ON",
                // "ADDED BY",
              ]}
              headerSelector={[
                "color_tag",
                "formatted_patient_name",
                "age",
                "fomatted_sex",
                "birthdate",
                "status",
                // "phone_no",
                // "added_on",
                // "added_by_name",
              ]}
              tableData={allPatients}
              loading={showLoader}
              isClickable={true}
              rowClickPath={"/patients/profile"}
              onRowClick={handleRowClick}
              tablePages={10}
              handleTableChange={handleTableChange}
              filterConfig={filterConfig}
              totalSize={totalSize}
              isSearch={true}
              searchExcluded={["color_tag", "status"]}
              // customEmptyText={
              //   <div className="d-flex flex-column align-items-center">
              //     <em className="text-muted my-5">
              //       Search for a prescription by brand or generic name to view
              //       the list.
              //     </em>
              //   </div>
              // }
              customEmptyText={
                <div className="d-flex flex-column align-items-center">
                  <em className="text-muted my-5 text-center">
                    Please search for a patient by <strong>last name</strong>,{" "}
                    <strong>first name</strong>, or <strong>middle name</strong>{" "}
                    to display the list of patients.
                  </em>
                </div>
              }
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default PatientManager;
